import store from "src/store";
import http from "src/services/http";
import * as types from "../types/delivery";

export const saveDeliveryConfig = (dados) => {
  store.dispatch({
    type: types.SET_LOADING_DELIVERY_CONFIGURACAO,
    payload: true,
  });
  return new Promise((resolve, reject) => {
    http.put("/api/v2/empresa/delivery", dados).then(
      (response) => {
        store.dispatch([
          { type: types.SET_DELIVERY_CONFIGURACAO, payload: response.data },
          { type: types.SET_LOADING_DELIVERY_CONFIGURACAO, payload: false },
        ]);
        resolve();
      },
      (e) => {
        store.dispatch([
          { type: types.SET_LOADING_DELIVERY_CONFIGURACAO, payload: false },
        ]);
        resolve();
      }
    );
  });
};

export const loadDeliveryConfig = () => {
  store.dispatch({
    type: types.SET_LOADING_DELIVERY_CONFIGURACAO,
    payload: true,
  });
  return (dispatch) => {
    http.get("/api/v2/empresa/delivery").then(
      (response) => {
        dispatch([
          {
            type: types.SET_DELIVERY_CONFIGURACAO,
            payload: response.data,
          },
          {
            type: types.SET_LOADING_DELIVERY_CONFIGURACAO,
            payload: false,
          },
        ]);
      },
      (e) => {
        dispatch({
          type: types.SET_LOADING_DELIVERY_CONFIGURACAO,
          payload: false,
        });
      }
    );
  };
};
